import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function statesReducer(state = initialState.states, action) {
  switch (action.type) {
    case types.LOAD_STATES_SUCCESS:
      return action.states;
    default:
      return state;
  }
}

export function programTypes(state = initialState.programTypes, action) {
  switch (action.type) {
    case types.LOAD_PROGRAM_TYPES_SUCCESS:
      return action.programTypes.split(",");
    default:
      return state;
  }
}
